export default __webpack_public_path__ + "9c4046aaccfdb7dad8c5f7395d8c1c54.svg";